<template>
  <div class="box">
    <div class="tabselecr_box">
      <div>
        <el-input
          v-model="query.employee"
          clearable
          style="width:200px;margin-right: 20px;"
          placeholder="员工的编号/姓名"
        />
        <el-input
          v-model="query.customer"
          clearable
          style="width:200px;margin-right: 10px;"
          placeholder="客户备注名称/客户id"
        />
        <el-select
          v-model="query.onlyMe"
          placeholder="请选择"
          style="width:200px;margin:0px 10px"
        >
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-date-picker
          v-model="timearr"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:410px"
          :picker-options="pickerOptions"
          :default-time="['00:00:00', '23:59:59']"
          :clearable="false"
          @change="datavalue"
        />
        <el-button
          type="primary"
          style="margin-left:10px"
          icon="el-icon-search"
          @click="searchclick"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="rechargeclick"
        >重置</el-button>
      </div>

      <el-button
        type="primary"
        class="add"
        @click="addConfig"
      >添加</el-button>

    </div>
    <div style="padding-bottom: 20px;">
      你选择的标签是：<el-tag>{{ tagName }}</el-tag>
    </div>
    <div class="selectbox">
      <div style="display: flex;">
        <el-checkbox
          v-model="fullName"
          style="margin-bottom:15px ;"
          @change="whole"
        >本页全选</el-checkbox>
        <div style="margin-left: 10px;flex-shrink: 0;margin-top: 2px;">所有结果全选：</div>
        <el-switch
          v-model="jievalue"
          active-color="#13ce66"
          inactive-color="#ccc"
          @change="quandwer"
        />
      </div>
      <div class="checkbox-list">
        <div
          v-for="(item,index) in listData"
          :key="item.id"
          class="checkbox-item"
        >
          <el-checkbox
            v-model="item.checked"
            @click.native.stop
            @change="itenclick(item,index)"
          >
            <div class="list">
              <p>
                客户：{{ item.remark }}
              </p>
              <p style="margin-left: 20px;">
                归属员工：{{ item.employee_name }}
              </p>
            </div>
          </el-checkbox>
        </div>
      </div>

    </div>
    <div class="pagebox">
      <pagination-right
        :current-page="query.page"
        :total="total"
        :page-size="query.pageSize"
        :page-sizes="[10, 50, 100]"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

  </div>

</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { corpExternalUsersListForTag, markTag, markTagV2 } from '@/api/numberTemplatemessage'
export default {
  // name: 'Label',
  components: {
    PaginationRight
  },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10,
        employee: '',
        customer: '',
        onlyMe: 2
      },
      total: null,
      listData: [],
      corp_id: [],
      tableList: [],
      multipleSelection: [],
      newData: [],
      tag_id: '',
      arrs: [],
      accountarr: [
        {
          value: 1,
          label: '组内的客户'
        },
        {
          value: 2,
          label: '我关联的客户'
        }
      ],
      tagName: null,
      timearr: [],
      pickerOptions: {
        // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() > Date.now()
        }
      },
      start_time: '',
      end_time: '',
      jievalue: false,
      quxiaoarr: [],
      exclude_external: []
    }
  },

  computed: {
    fullName: {
      get() {
        return this.listData.every(item => item.checked)
      },
      set(value) {
        for (let i = 0; i < this.listData.length; i++) {
          this.listData[i].checked = value
        }
        // this.listData.forEach(item => {
        //   item.checked = value
        // })
      }
    }
  },
  created() {
    this.corp_id = this.$route.query.id
    console.log('this.corp_id---add', this.corp_id)
    // this.list()
  },
  mounted() {},
  activated() {},
  methods: {
    send(tagid, tagname) {
      console.log('tagid', tagid)
      this.tag_id = tagid
      this.tagName = tagname
      this.corp_id = this.$route.query.id
      this.list()
    },
    // 客户信息
    async list() {
      const data = await corpExternalUsersListForTag({
        page: this.query.page,
        page_size: this.query.pageSize,
        staff_keyword: this.query.employee,
        follow_keyword: this.query.customer,
        onlyMe: this.query.onlyMe,
        corp_id: this.corp_id,
        start_time: this.start_time,
        end_time: this.end_time
      })
      if (!data || !data.data) {
        this.$message.error('服务器请求失败，请稍后重试')
        return
      }
      if (data.data === null) {
        this.listData = []
        this.total = null
        return
      }
      // this.listData = data.data.list
      this.listData = data.data.list.map(item => {
        return {
          id: item.id,
          user_id: item.user_id,
          checked: false,
          external_user_id: item.external_user_id,
          employee_name: item.employee_name,
          remark: item.remark
        }
      })
      console.log('list--------', this.listData, this.quxiaoarr, this.jievalue)
      this.total = data.data.total
      if (this.jievalue === true) {
        this.listData = this.listData.map(item => {
          // this.arrs.push(item)
          // 检查 quxiaoarr 中是否存在相同的 id
          const existsInQuxiao = this.quxiaoarr.some(quxiaoItem => quxiaoItem.id === item.id)
          // 如果存在，保持 checked 不变；如果不存在，将 checked 设为 true
          return {
            ...item,
            checked: existsInQuxiao ? item.checked : true
          }
        })
        console.log('this.listData', this.listData)
        const arrsIds = new Set(this.arrs.map(item => item.id))
        const itemsToAdd = this.listData.filter(item => !arrsIds.has(item.id) && item.checked)
        this.arrs.push(...itemsToAdd)
      }

      if (this.arrs.length > 0) {
        console.log('arrs----', this.arrs)
        for (let a = 0; a < this.arrs.length; a++) {
          for (let b = 0; b < this.listData.length; b++) {
            if (this.arrs[a].id === this.listData[b].id) {
              this.listData[b].checked = true
            }
          }
        }

        // this.arrs.forEach(item => {
        //   this.listData.forEach((items) => {
        //     if (item.id === items.id) {
        //       items.checked = true
        //     }
        //   })
        // })
      }
    },

    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    datavalue(val) {
      console.log('val', val)
      this.start_time = val[0]
      this.end_time = val[1]
    },
    handleSelectionChange(val) {
      console.log('select--------', val)
      this.multipleSelection = val
    },
    // 添加客户
    async addConfig() {
      console.log('this.arrs  add-----', this.arrs)
      this.newData = []
      for (var i = 0; i < this.arrs.length; i++) {
        this.newData.push({
          user_id: this.arrs[i].user_id,
          external_user_id: this.arrs[i].external_user_id
        })
      }
      this.exclude_external = []
      for (var y = 0; y < this.quxiaoarr.length; y++) {
        this.exclude_external.push(this.quxiaoarr[y].external_user_id)
      }

      console.log('this.newData', this.newData)
      console.log('111')
      if (this.jievalue === false) {
        if (this.newData.length <= 0) {
          this.$message.error('请选择客户')
          return
        }
      }
      this.$confirm(
        this.jievalue === true ? `您确定将员工信息【${this.query.employee}】客户信息【${this.query.customer}】开始时间【${this.start_time}】结束时间【${this.end_time}】的客户增加标签【${this.tagName}】吗?` : `您确定要将选中的【${this.newData.length}】个客户增加标签【${this.tagName}】吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        if (this.jievalue === true) {
          markTagV2({
            corp_id: this.corp_id,
            tag_id: this.tag_id,
            // user_external: this.newData
            exclude_external: this.exclude_external,
            start_time: this.start_time,
            end_time: this.end_time,
            staff_keyword: this.query.employee,
            follow_keyword: this.query.customer,
            onlyMe: this.query.onlyMe
            // tag: this.labelForm.children
          }).then(data => {
            console.log('data', data)
            if (data.code === 200) {
              this.$message({
                type: 'success',
                message: `${data.message}`
              })
              this.$emit('addcustom')
            }
          })
        } else {
          markTag({
            corp_id: this.corp_id,
            tag_id: this.tag_id,
            user_external: this.newData
            // tag: this.labelForm.children
          }).then(data => {
            console.log('data', data)
            if (data.code === 200) {
              this.$message({
                type: 'success',
                message: `${data.message}`
              })
              this.$emit('addcustom')
            }
          })
        }
      })
    },
    searchclick() {
      this.query.page = 1
      this.quxiaoarr = []
      this.exclude_external = []
      this.list()
    },
    rechargeclick() {
      console.log('recharge')
      this.query.page = 1
      this.query.employee = null
      this.query.customer = null
      this.timearr = []
      this.start_time = ''
      this.end_time = ''
      this.quxiaoarr = []
      this.exclude_external = []
      this.list()
    },
    whole(e) {
      console.log('e', e)
      if (!e) {
        console.log('666')
        let index = ''
        for (let d = 0; d < this.listData.length; d++) {
          if (this.listData[d].checked === false) {
            // console.log(item, 'item----')
            index = this.arrs.findIndex(items => {
              return items.id === this.listData[d].id
            })
          }
          this.arrs.splice(index, 1)
        }
        // this.arr.forEach((item) => {
        //   if (item.checked === false) {
        //     console.log(item, 'item----')
        //     index = this.arrs.findIndex((items) => {
        //       return items.id === item.id
        //     })
        //   }
        //   this.arrs.splice(index, 1)
        // })
        console.log('不全选', this.listData)
        const quxiaoarrIds = new Set(this.quxiaoarr.map(item => item.id))
        const itemsToAdd = this.listData.filter(item => !quxiaoarrIds.has(item.id))
        this.quxiaoarr.push(...itemsToAdd)

        console.log('this.quxiaoarr取消', this.quxiaoarr)
      } else {
        console.log(77, '全选', this.listData)
        for (let c = 0; c < this.listData.length; c++) {
          if (this.listData[c].checked === true) {
            this.arrs.map(re => re.id).includes(this.listData[c].id) ||
              this.arrs.push({
                id: this.listData[c].id,
                user_id: this.listData[c].user_id,
                external_user_id: this.listData[c].external_user_id,
                employee_name: this.listData[c].employee_name,
                remark: this.listData[c].remark
              })
          }
        }
        // 获取 listData 中的所有 id
        const listDataIds = new Set(this.listData.map(item => item.id))
        const filteredQuxiaoarr = this.quxiaoarr.filter(item => !listDataIds.has(item.id))
        console.log(filteredQuxiaoarr)
        this.quxiaoarr = filteredQuxiaoarr
        console.log('this.quxiaoarr全选', this.quxiaoarr)
        // this.arr.forEach((item) => {
        //   if (item.checked === true) {
        //     this.arrs.map(re => re.id).includes(item.id) || this.arrs.push({
        //       id: item.id,
        //       user_id: item.user_id,
        //       external_user_id: item.external_user_id,
        //       employee_name: item.employee_name,
        //       remark: item.remark
        //     })
        //   }
        // })
      }
    },
    itenclick(item, index) {
      if (item.checked === true) {
        this.arrs.push({
          id: item.id,
          user_id: item.user_id,
          external_user_id: item.external_user_id,
          employee_name: item.employee_name,
          remark: item.remark
        })
        console.log('item', item)
        const index = this.quxiaoarr.findIndex(v => v.id === item.id)
        if (index !== -1) {
          this.quxiaoarr.splice(index, 1)
        }
      } else {
        console.log('取消的当前项', item)
        this.quxiaoarr.push(item)
        const index = this.arrs.findIndex(v => v.id === item.id)
        if (index !== -1) {
          this.arrs.splice(index, 1)
        }
      }
    },
    quandwer(val) {
      console.log('val', val)
      if (val === true) {
        console.log(77, '全选', this.listData)
        // for (let c = 0; c < this.listData.length; c++) {
        //   if (this.listData[c].checked === true) {
        //     this.arrs.map(re => re.id).includes(this.listData[c].id) ||
        //       this.arrs.push({
        //         id: this.listData[c].id,
        //         user_id: this.listData[c].user_id,
        //         external_user_id: this.listData[c].external_user_id,
        //         employee_name: this.listData[c].employee_name,
        //         remark: this.listData[c].remark
        //       })
        //   }
        // }
        this.listData.forEach(item => {
          item.checked = true
          this.arrs.map(re => re.id).includes(item.id) || this.arrs.push({ id: item.id, user_id: item.user_id, external_user_id: item.external_user_id, employee_name: item.employee_name, remark: item.remark })
        })
        // 获取 listData 中的所有 id
        const listDataIds = new Set(this.listData.map(item => item.id))
        const filteredQuxiaoarr = this.quxiaoarr.filter(item => !listDataIds.has(item.id))
        console.log(filteredQuxiaoarr)
        this.quxiaoarr = filteredQuxiaoarr
        console.log('this.quxiaoarr全选', this.quxiaoarr)
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.box {
  width: 100%;
  height: 70vh;
}
.add {
  margin-right: 20px;
}
.listbox {
  display: flex;
  align-items: center;
  justify-content: left;
}
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.box >>> .el-table th.is-leaf,
.el-table td {
  border-bottom: 0px solid #dfe6ec !important;
}
.selectbox {
  height: 80%;
  overflow: auto;
}
.checkbox-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}
.checkbox-item {
  width: 33%;
}
.box >>> .el-table__header .el-table-column--selection .cell .el-checkbox:after {
  color: #909399;
  content: '全选';
  font-size: 14px;
  margin-left: 5px;
  font-weight: bold;
}
.list {
  display: flex;
  justify-content: left;
}

</style>
